import { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";

async function fetchState() {
    const response = await fetch(process.env.REACT_APP_TB2_API_URL + '/events/geolocation/state');
    if (!response.ok) return 'Not available'; // If request fails, return 'Not available'
    const data = await response.json();
    return data?.state ?? 'Not available';
}

export function ConsentGuard({ children }) {
    const location = useLocation();
    const [stateCode, setStateCode] = useState(null);

    // Fetch state once
    useEffect(() => {
        let mounted = true;
        fetchState().then((s) => mounted && setStateCode(s)).catch(() => {});
        return () => { mounted = false; };
    }, []);

    const maybeShowBanner = useCallback(() => {
        if (location.pathname === '/cookie-policy') return; // Don't show banner on cookie policy page
        if (stateCode !== "CA" && stateCode !== 'Not available') return; // Only show for CA or unknown state
        const choiceMade = !!localStorage.getItem('silktideCookieBanner_InitialChoice');

        if (!choiceMade) window.silktideCookieBannerManager?.openBanner?.();
    }, [location.pathname, stateCode]);

    // Check for consent banner display in every route change
    useEffect(() => {
        maybeShowBanner();
    }, [maybeShowBanner]);

    // Try to show banner when Silktide manager becomes available
    useEffect(() => {
    window.addEventListener("silktide:ready", maybeShowBanner);
        return () => window.removeEventListener("silktide:ready", maybeShowBanner);
    }, [maybeShowBanner]);

    return children;
}
